const authenticationBasicKey = {
    user: 'baaldahab_api',
    password: 'Baaldahab2O!8',
   
};

export default authenticationBasicKey;